import { useRef, useState } from "react";

interface Props {
  beforeUrl: string;
  afterUrl: string;
  beforeLabel: string;
  afterLabel: string;
}

export function PhotoCompare({ beforeUrl, afterUrl, beforeLabel, afterLabel }: Props) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [split, setSplit] = useState(50);

  function updateFromClientX(clientX: number) {
    const el = containerRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const pct = ((clientX - rect.left) / rect.width) * 100;
    setSplit(Math.min(96, Math.max(4, pct)));
  }

  function handlePointerDown(e: React.PointerEvent) {
    (e.target as Element).setPointerCapture(e.pointerId);
    updateFromClientX(e.clientX);
  }

  return (
    <div
      ref={containerRef}
      className="relative aspect-[16/10] select-none overflow-hidden rounded-inner border border-line"
      onPointerDown={handlePointerDown}
      onPointerMove={(e) => {
        if (e.buttons === 1) updateFromClientX(e.clientX);
      }}
    >
      <img src={afterUrl} alt={afterLabel} className="absolute inset-0 h-full w-full object-cover" />
      {/* Mismo tamaño que la imagen "after"; solo se recorta con clip-path para que el barrido quede alineado píxel a píxel */}
      <img
        src={beforeUrl}
        alt={beforeLabel}
        className="absolute inset-0 h-full w-full object-cover"
        style={{ clipPath: `inset(0 ${100 - split}% 0 0)` }}
      />

      <span className="absolute left-2 top-2 z-[2] rounded-full border border-line bg-[rgba(6,8,15,.7)] px-2 py-[3px] font-mono text-[9px] tracking-[0.12em] text-muted">
        {beforeLabel}
      </span>
      <span className="absolute right-2 top-2 z-[2] rounded-full border border-accent-bright/30 bg-[rgba(6,8,15,.7)] px-2 py-[3px] font-mono text-[9px] tracking-[0.12em] text-accent-bright">
        {afterLabel}
      </span>

      <div
        className="absolute top-0 bottom-0 z-[3] w-0.5 bg-accent shadow-[0_0_12px_rgba(46,107,255,.7)]"
        style={{ left: `${split}%` }}
      />
      <div
        className="absolute top-1/2 z-[4] grid h-[34px] w-[34px] -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full bg-accent text-[13px] text-white shadow-[0_4px_16px_rgba(46,107,255,.6)]"
        style={{ left: `${split}%` }}
      >
        ⇆
      </div>
    </div>
  );
}
